import { Alert, Button, Typography } from "antd";

/**
 * Trạng thái dữ liệu cũ (stale — UIUX §1, BA-06 §5): dữ liệu đang hiển thị
 * có thể chưa cập nhật sau khi làm mới thất bại. Banner nêu thời điểm đồng bộ
 * gần nhất + hành động làm mới; giữ nguyên dữ liệu cũ trên màn hình.
 */
export function StaleState({ lastSyncedAt, onRefresh }: {
  readonly lastSyncedAt?: string;
  readonly onRefresh?: () => void;
}) {
  return (
    <Alert
      type="info"
      showIcon
      message="Dữ liệu đang được đồng bộ lại"
      description={
        lastSyncedAt ? (
          <Typography.Text>
            Bản cập nhật gần nhất: <Typography.Text strong>{lastSyncedAt}</Typography.Text>
          </Typography.Text>
        ) : undefined
      }
      action={
        onRefresh ? (
          <Button size="small" onClick={onRefresh}>
            Làm mới
          </Button>
        ) : null
      }
    />
  );
}
